export const getLocalizationByCountry = (countryCode: string) => {
  switch (countryCode) {
    case "SA":
      return { lang: "ar", currency: "SAR", nationality: "SA" };
    case "KW":
      return { lang: "ar", currency: "KWD", nationality: "KW" };
    case "AE":
      return { lang: "en", currency: "AED", nationality: "AE" };
    default:
      return { lang: "en", currency: "USD", nationality: "US" };
  }
};
